export default __webpack_public_path__ + "static/media/delete.cac00287.svg";